/**
 * Converts bytes to a human-readable string (e.g. "256 GB").
 *
 * @param {number|null|undefined} bytes - The number of bytes to format
 * @param {number} [decimals=1] - Number of decimal places
 * @returns {string} Formatted string or "–" if value is missing
 */
export default function FormatBytes(bytes, decimals = 1) {
  if (bytes == null || bytes === 0) return "–";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + " " + sizes[i];
}
